import { Navigate, useParams } from "react-router-dom";

const LegacyLifeSignalDetailRedirect = () => {
  const { seniorUserAccountId } = useParams();
  return <Navigate to={`/admin/users/seniors/${seniorUserAccountId ?? ""}?tab=care`} replace />;
};

export default LegacyLifeSignalDetailRedirect;
